import script from "./JobCellElementLite.vue?vue&type=script&setup=true&lang=ts"
export * from "./JobCellElementLite.vue?vue&type=script&setup=true&lang=ts"

import "./JobCellElementLite.vue?vue&type=style&index=0&id=058c2c3f&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-058c2c3f"]])

export default __exports__
import QChatMessage from 'quasar/src/components/chat/QChatMessage.js';
import QBadge from 'quasar/src/components/badge/QBadge.js';
import qInstall from "../../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QChatMessage,QBadge});
